// extracted by mini-css-extract-plugin
export var active = "_5k-b";
export var activeIndicator = "_5k-6";
export var animate = "_5k-a";
export var disabled = "_5k-c";
export var flat = "_5k-1";
export var fullWidth = "_5k-3";
export var lg = "_5k-9";
export var md = "_5k-8";
export var redoButtonTabGroup = "_5k-0";
export var sm = "_5k-7";
export var tabButton = "_5k-4";
export var tabButtonsContainer = "_5k-2";
export var xs = "_5k-5";